import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-test-api',
  standalone: true,
  imports: [],
  templateUrl: './test-api.component.html',
  styleUrl: './test-api.component.scss'
})
export class TestApiComponent implements OnInit {

  constructor(private http: HttpClient) {}

  ngOnInit() {
    const rawToken = localStorage.getItem('token');
    const token = rawToken ? rawToken.replace(/"/g, '') : '';
    console.log('Token:', token);
    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      })
    };

    this.http.get('http://localhost:8000/api/commentaires', httpOptions).subscribe({
      next: (data) => {
        console.log('Success:', data);
      },
      error: (error) => {
        console.error('Error:', error);
      }
    });
  }
}